import { useTranslation } from "react-i18next";
import { Icon } from "semantic-ui-react";

import { usePinOptions } from "components/PinModal/hooks";
import "components/PinModal/PinModal.scss";
import { PinTypeIcon } from "components/PinTypeIcon";
import { getShopIconColor } from "modules/AppointmentDetails/components/Interventions/components";

import type { Dealer } from "models";

export const useGetPinOptionsDropdownOptions = (dealer?: Dealer | null) => {
  const { t } = useTranslation();

  const { pinOptions } = usePinOptions();

  const pinTypeOptions =
    pinOptions?.pin_types.map(pinType => ({
      key: pinType.name,
      text: t(pinType.label) || pinType.name,
      value: pinType.id,
      icon: <PinTypeIcon pinTypeId={pinType.id} />
    })) ?? [];

  const pinStatusOptions =
    pinOptions?.pin_statuses.map(pinStatus => ({
      key: pinStatus.name,
      text: t(pinStatus.label) || pinStatus.name,
      value: pinStatus.id
    })) ?? [];

  const pinOrderOptions =
    pinOptions?.pin_order_statuses.map(pinOrder => ({
      key: pinOrder.name,
      text: t(pinOrder.label) || pinOrder.name,
      value: pinOrder.id,
      icon: <Icon className="shopping cart" color={getShopIconColor(pinOrder.id)} />
    })) ?? [];

  const pinWarrantyOptions =
    pinOptions?.warranty_types
      .filter(pinWarranty => dealer?.enabled_warranty_types?.includes(pinWarranty.id))
      .map(pinWarranty => ({
        key: pinWarranty.name,
        text: t(pinWarranty.label) || pinWarranty.name,
        value: pinWarranty.id
      })) ?? [];

  return { pinTypeOptions, pinStatusOptions, pinOrderOptions, pinWarrantyOptions };
};
